export default __webpack_public_path__ + "static/media/universalism.1d718850.webp";